<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <!-- The id in the next line maps the walkthrough to that div element. Please do not remove this id -->
    <div
      id="fundAcctTourItem1"
      class="md:text-xl text-left -mt-8 text-root-2 font-bold mb-3"
    >
      Deposit Agreement
    </div>
    <div class="overflow-y-scroll h-96 font-normal">
      <div
        v-html="agreementData"
        style="word-break: normal"
        class="text-sm xl:text-base text-black"
      ></div>
    </div>
    <div class="flex justify-center items-center mt-8">
      <div
        class="flex justify-center items-center bg-primary text-white rounded-lg py-2 text-sm md:text-base w-11/12 font-normal hover:opacity-80"
        @click="proceedToDepositAmount"
      >
        I Agree
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  name: 'agreementDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    agreementData: {
      type: String
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    proceedToDepositAmount () {
      this.$emit('closeDialog')
      this.$emit('agreementConfirmed')
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 16px;
  padding: 5px;
  background-color: white;
}

>>> .el-dialog__close .el-icon .el-icon-close {
  color: black !important;
}
</style>
